import { Image } from '@mantine/core'
import up1 from "../Assets/Images/up1.jpg"
import up2 from "../Assets/Images/up2.jpg"
import up3 from "../Assets/Images/up3.jpg"
import up4 from "../Assets/Images/up4.jpg"
import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

export const ChangingPictures = () => {

  const [ currentImage, setCurrentImage ] = useState({
    images: [ up1, up2, up3, up4 ],
    image: up1,
    number: 0
  })

  const updateCount = () => {
    if(currentImage.number < 4){
      setTimeout(() => {
        setCurrentImage(e => ({ images:[...e.images], image:e.images[currentImage.number + 1], number: currentImage.number + 1 }) )
      }, 6000)
    }
  }

  useEffect(() => {
    if(currentImage.number < 4){
      updateCount()
    } else {
      setCurrentImage(e => ({ images:[...e.images], image:e.images[0], number: 0 }) )
      clearInterval()
    }

    return () => clearInterval()
  }, [currentImage.number])

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={currentImage.image}
        initial={{ opacity:0 }}
        animate={{ opacity:1 }}
        exit={{ opacity:0 }}
        transition={{ duration:.5 }}
      >
        <Image
          src={currentImage.image}
          alt="An abstract image"
          height={1000}
          style={{
            filter:"grayscale(0.25) brightness(.75)"
          }}
        />
      </motion.div>
    </AnimatePresence>
  )
}
